import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  background-color: white;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: var(--primary-color-transparent);
    color: var(--primary-color);
  }

  /* Make buttons more compact on mobile but still allow longer text */
  @media (max-width: 767px) {
    padding: 6px 12px;
    font-size: 13px;
    max-width: 250px;
  }
`;

const SuggestionButton = ({ text, onClick }) => {
  return (
    <Button onClick={() => onClick(text)} title={text}>
      {text}
    </Button>
  );
};

export default SuggestionButton;
